package com.mgacreative.hotel.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Agency(
    val id: String? = null,
    @SerialName("tenant_id") val tenantId: String? = null,
    val name: String,
    @SerialName("contact_info") val contactInfo: String? = null,
    @SerialName("commission_rate") val commissionRate: Double? = null,
    @SerialName("tursab_no") val tursabNo: String? = null,
    val address: String? = null,
    @SerialName("tax_office") val taxOffice: String? = null,
    @SerialName("tax_number") val taxNumber: String? = null,
    @SerialName("authorized_person") val authorizedPerson: String? = null,
    val phone: String? = null,
    val email: String? = null,
    @SerialName("created_at") val createdAt: String? = null
)

@Serializable
data class AgencyAllotment(
    val id: String? = null,
    @SerialName("tenant_id") val tenantId: String? = null,
    @SerialName("agency_id") val agencyId: String,
    @SerialName("start_date") val startDate: String,
    @SerialName("end_date") val endDate: String,
    @SerialName("allotted_rooms") val allottedRooms: Int = 0,
    @SerialName("created_at") val createdAt: String? = null,
    // Joined data
    val agencies: Agency? = null
)
